<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-form
                                ref="form"
                                lazy-validation
                            >
                                <v-row>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-select
                                            :items="codes"
                                            item-text="ServiceCode"
                                            item-value="ServiceCode"
                                            label="Service Code"
                                            v-model="newCode"
                                            :rules="requiredRules"
                                            @change="calcDailyUnits"
                                            return-object
                                        >
                                            <template v-slot:append-item>
                                                <v-divider class="mb-2"></v-divider>
                                                <v-btn
                                                    class="ma-2 white--text"
                                                    color="success"
                                                    @click="showCodeDialog()"
                                                >
                                                    Add Code
                                                </v-btn>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="newTitle"
                                            label="Service Code Title"
                                            disabled
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="3">
                                        <v-text-field
                                            v-model="newUnits"
                                            label="Units"
                                            :readonly="readonly"
                                            :disabled="disabled"
                                            :rules="requiredRules"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6" v-if="requiredTime">
                                        <v-select
                                            v-model="timeStart"
                                            label="Time Start"
                                            prepend-icon="mdi-clock-time-four-outline"
                                            :items="times"
                                            item-text="Time"
                                            item-value="Value"

                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6" v-if="requiredTime">
                                        <v-select
                                            v-model="timeEnd"
                                            label="Time End"
                                            prepend-icon="mdi-clock-time-four-outline"
                                            @change="calcUnits"
                                            :items="times"
                                            item-text="Time"
                                            item-value="Value"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-menu
                                            ref="menu"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newDate"
                                                    label="Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newDate"
                                                no-title
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.menu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12" md="6">
                                        <v-checkbox
                                            @click="addSignature()"
                                            label="Signature"
                                            v-model="checkSignature"
                                        ></v-checkbox>
                                        <v-text-field v-if="signed === true" v-model="newSignature"
                                                      readonly></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrintModal()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createAttendance"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn class="white--text" color="#259647" @click="addAttendance()"
                               v-if="createAttendance && !isAuditorRole">Save
                        </v-btn>
                        <v-btn class="white--text" color="#259647" @click="updateAttendance()"
                               v-if="!createAttendance && !isAuditorRole">Update
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <add-service-code-dialog @update-codes="handleNewCode"/>

        <Foot/>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../../components/ClientNav'
import AddServiceCodeDialog from '../../../components/client/attendance/AddServiceCodeDialog';
import Foot from '../../../components/Footer'
import moment from 'moment'
//import { mapState, mapActions, mapGetters } from "vuex";
import {displaySuccess, displayError} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;
export default {
    components: {
        ClientNav,
        AddServiceCodeDialog,
        Foot,
    },
    data: function () {
        return {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            msg: false,
            snackbarColor: "black",
            search: "",
            text: "",
            attendances: [],
            attendance: {},
            codes: [],
            users: [],
            clientID: this.$route.params.clientID,
            attendanceId: this.$route.params.id,
            token: localStorage.getItem('token'),
            userID: localStorage.getItem('userID'),
            staff: localStorage.getItem('Name'),
            tempData: [],
            titleForm: "New Attendance Record",
            attendanceID: "",
            newName: "",
            newTitle: "",
            newUnits: "",
            newCode: "",
            newDate: "",
            newSignature: "",
            Rate: "",
            signed: false,
            checkSignature: false,
            //newUnits: "",
            newServiceUnit: "",
            editedIndex: -1,
            editedItem: {
                name: "",
                code: "",
                date: "",
                signature: "",
                unit: "",
                serviceUnit: "",
            },
            defaultItem: {
                name: "",
                code: "",
                date: "",
                signature: "",
                unit: "",
                serviceUnit: "",
            },
            isLoading: true,
            requiredRules: [
                v => !!v || 'This is required',
            ],
            timeStartPicker: false,
            timeStart: "",
            timeEndPicker: false,
            timeEnd: "",
            timeEndAdjust: null,
            requiredTime: false,
            newServiceCodeDialog: false,
            newServiceCodeAdd: "",
            maskDate: [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
            maskTimeStart: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
            maskTimeEnd: [/[1]/, /\d/, ':', /[0-5]/, /\d/, ' ', /[A,P]/, 'M'],
            showStartTimePicker: false,
            showEndTimePicker: false,
            timeStartDisplay: '',
            timeEndDisplay: '',
            readonly: true,
            disabled: true,
            client: false,
            createAttendance: false,

            times: [
                {Time: "6:00am", Value: "6:00am"}, {Time: "6:15am", Value: "6:15am"}, {
                    Time: "6:30am",
                    Value: "6:30am"
                }, {Time: "6:45am", Value: "6:45am"},
                {Time: "7:00am", Value: "7:00am"}, {Time: "7:15am", Value: "7:15am"}, {
                    Time: "7:30am",
                    Value: "7:30am"
                }, {Time: "7:45am", Value: "7:45am"},
                {Time: "8:00am", Value: "8:00am"}, {Time: "8:15am", Value: "8:15am"}, {
                    Time: "8:30am",
                    Value: "8:30am"
                }, {Time: "8:45am", Value: "8:45am"},
                {Time: "9:00am", Value: "9:00am"}, {Time: "9:15am", Value: "9:15am"}, {
                    Time: "9:30am",
                    Value: "9:30am"
                }, {Time: "9:45am", Value: "9:45am"},
                {Time: "10:00am", Value: "10:00am"}, {Time: "10:15am", Value: "10:15am"}, {
                    Time: "10:30am",
                    Value: "10:30am"
                }, {Time: "10:45am", Value: "10:45am"},
                {Time: "11:00am", Value: "11:00am"}, {Time: "11:15am", Value: "11:15am"}, {
                    Time: "11:30am",
                    Value: "11:30am"
                }, {Time: "11:45am", Value: "11:45am"},
                {Time: "12:00pm", Value: "12:00pm"}, {Time: "12:15pm", Value: "12:15pm"}, {
                    Time: "12:30pm",
                    Value: "12:30pm"
                }, {Time: "12:45pm", Value: "12:45pm"},
                {Time: "1:00pm", Value: "13:00pm"}, {Time: "1:15pm", Value: "13:15pm"}, {
                    Time: "1:30pm",
                    Value: "13:30pm"
                }, {Time: "1:45pm", Value: "13:45pm"},
                {Time: "2:00pm", Value: "14:00pm"}, {Time: "2:15pm", Value: "14:15pm"}, {
                    Time: "2:30pm",
                    Value: "14:30pm"
                }, {Time: "2:45pm", Value: "14:45pm"},
                {Time: "3:00pm", Value: "15:00pm"}, {Time: "3:15pm", Value: "15:15pm"}, {
                    Time: "3:30pm",
                    Value: "15:30pm"
                }, {Time: "3:45pm", Value: "15:45pm"},
                {Time: "4:00pm", Value: "16:00pm"}, {Time: "4:15pm", Value: "16:15pm"}, {
                    Time: "4:30pm",
                    Value: "16:30pm"
                }, {Time: "4:45pm", Value: "16:45pm"},
                {Time: "5:00pm", Value: "17:00pm"}, {Time: "5:15pm", Value: "17:15pm"}, {
                    Time: "5:30pm",
                    Value: "17:30pm"
                }, {Time: "5:45pm", Value: "17:45pm"},
                {Time: "6:00pm", Value: "18:00pm"}, {Time: "6:15pm", Value: "18:15pm"}, {
                    Time: "6:30pm",
                    Value: "18:30pm"
                }, {Time: "6:45pm", Value: "18:45pm"},
                {Time: "7:00pm", Value: "19:00pm"}, {Time: "7:15pm", Value: "19:15pm"}, {
                    Time: "7:30pm",
                    Value: "19:30pm"
                }, {Time: "7:45pm", Value: "19:45pm"},
                {Time: "8:00pm", Value: "20:00pm"}, {Time: "8:15pm", Value: "20:15pm"}, {
                    Time: "8:30pm",
                    Value: "20:30pm"
                }, {Time: "8:45pm", Value: "20:45pm"},
                {Time: "9:00pm", Value: "21:00pm"}, {Time: "9:15pm", Value: "21:15pm"}, {
                    Time: "9:30pm",
                    Value: "21:30pm"
                }, {Time: "9:45pm", Value: "21:45pm"},
                {Time: "10:00pm", Value: "22:00pm"}, {Time: "10:15pm", Value: "22:15pm"}, {
                    Time: "10:30pm",
                    Value: "22:30pm"
                }, {Time: "10:45pm", Value: "22:45pm"},
                {Time: "11:00pm", Value: "23:00pm"}, {Time: "11:15pm", Value: "23:15pm"}, {
                    Time: "11:30pm",
                    Value: "23:30pm"
                }, {Time: "11:45pm", Value: "23:45pm"},

            ],
        }
    },

    computed: {
        addAttendanceDialog: {
            get() {
                this.getCodes();
                return this.$store.state.attendance.addAttendanceDialog;
            },
            set(val) {
                this.getCodes();
                this.$store.commit("attendance/SET_ADD_ATTENDANCE_DIALOG", val);
            },
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {
        newCode(newVal) {
            if (newVal && newVal.ServiceTitle) {
                this.newTitle = newVal.ServiceTitle;
            }
        }
    },
    created() {
        this.createAttendance = this.$route.query.createAttendance === 'true';
        this.getCodes();
        if (localStorage.getItem('userRole') === 'Administration' ||
            localStorage.getItem('userRole') === 'Client Services Manager' ||
            localStorage.getItem('userRole') === 'Program Coordinator' ||
            localStorage.getItem('userRole') === 'Human Resources' ||
            localStorage.getItem('userRole') === 'Compliance Manager') {

            this.readonly = false
            this.disabled = false
        }
        if (localStorage.getItem('userRole') === "Client") {
            this.client = true;
        }
    },

    mounted() {
        if (!this.createAttendance) {
            this.getAttendance();
        }

        window.addEventListener('keydown', async (event) => {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, this.downloadUrl, this.attendanceId, this.token, 'Attendance');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.attendanceId, this.token, 'Attendance');
        });
    },

    methods: {
        initialize() {
            this.attendances = [];
        },
        validate() {
            return this.$refs.form.validate()
        },

        viewAttendance(item) {
            this.titleForm = (typeof item.Title == 'undefined') ? "Viewing attendance " : 'Viewing ' + item.Title;
            this.editAttendance = true;
            this.newAttendance = false;
            this.newName = item.Name;
            this.newCode = item.Code;
            this.newTitle = item.Title;
            this.newDate = item.Date;
            this.timeStartDisplay = moment(item.Date + " " + item.TimeStart).format("hh:mma")
            this.timeEndDisplay = moment(item.Date + " " + item.TimeEnd).format("hh:mma")
            // if(item.ServiceUnit === "Quarter Hour" || item.ServiceUnit === "Session" || item.ServiceUnit === "Hourly"){
            //   this.requiredTime = true;
            //   this.timeStart = item.TimeStart;
            //   this.timeEnd = item.TimeEnd;
            // }
            this.timeStart = item.TimeStart;
            this.timeEnd = item.TimeEnd;
            this.newUnits = item.Units;
            this.newServiceUnit = item.ServiceUnit;
            this.attendanceID = item._id;
            if (this.newServiceUnit === "Quarter Hour" || this.newServiceUnit === "Session") {
                this.requiredTime = true
            } else {
                this.requiredTime = false;

            }
            if (item.Signature !== "") {
                this.newSignature = item.Signature;
                this.signed = true;
                this.checkSignature = true;
            }
        },

        calcUnits() {
            let timeDiff = moment.duration(moment.utc(moment(this.timeEnd, "HH:mm").diff(moment(this.timeStart, "HH:mm"))).format("HH:mm")).asMinutes();
            if (this.newServiceUnit == 'Quarter Hour') {
                this.newUnits = parseInt(timeDiff) / 15
            } else if (this.newServiceUnit == 'Session') {
                this.newUnits = parseInt(timeDiff) / 30
            } else if (this.newServiceUnit == 'Hourly') {
                this.newUnits = parseInt(timeDiff) / 60
            } else {
                this.newUnits = 1
            }
            this.calcForError()

        },

        calcDailyUnits() {
            this.newTitle = this.newCode.Title
            this.getUnitType()
            if (this.newServiceUnit === 'Daily') {
                this.newUnits = 1
            } else {
                this.newUnits = 0
                this.timeStart = ""
                this.timeEnd = ""
            }
        },

        getUnitType() {
            this.newServiceUnit = this.newCode.Units;
            if (this.newCode != "") {
                console.log(this.newCode.Units + " service Unit")
                switch (this.newServiceUnit) {
                    case "Quarter Hour":
                        this.requiredTime = true;
                        break;
                    case "Session":
                        this.requiredTime = true;
                        break;
                    case "Hourly":
                        this.requiredTime = true;
                        break;
                    case "Daily":
                        this.requiredTime = false;
                        break;
                    default:
                        return 0;
                }
            }

        },
        calcForError() {
            if (moment(this.timeStart, 'hh:mma').isAfter(moment(this.timeEnd, 'hh:mma')) ||
                moment(this.timeStart, 'hh:mma').isSame(moment(this.timeEnd, 'hh:mma'))) {

                this.msg = true;
                this.text = 'Please make sure the end time is after the start time';
                this.newUnits = 0
            }
        },

        close() {
            this.$router.go(-1);
            this.requiredTime = false;
            this.resetForm();
        },

        resetForm() {
            this.newName = "";
            this.newCode = "";
            this.newDate = "";
            this.newSignature = "";
            this.newUnits = "";
            this.newServiceUnit = "";
            this.signed = false;
            this.timeStart = "";
            this.timeEnd = "";
        },

        async updateAttendance() {

            this.newCode = this.newCode.ServiceCode ? this.newCode.ServiceCode : this.newCode;

            let req_body = {
                Name: this.newName,
                Code: this.newCode,
                Title: this.newTitle,
                Date: this.newDate,
                Signature: this.newSignature,
                Units: this.newUnits,
                ServiceUnit: this.newServiceUnit,
                TimeStart: this.timeStart,
                TimeEnd: this.timeEnd,
                Rate: this.Rate,
            };

            try {
                const response = await axios.put(`${url}/attendance/${this.attendanceId}`, req_body)

                if (response.status !== 200) {
                    displayError("An error occurred while updating the attendance record.")
                    return;
                }

                displaySuccess("The attendance record has been updated successfully.")
                this.getAttendances();
            } catch (error) {
                console.log({error});
            } finally {
                this.close();
            }
        },

        updateServiceCode(id, annualUnits, units) {
            var unitsToDeduct = units
            var newTotal = parseInt(annualUnits) - parseInt(unitsToDeduct)
            var req_body = {
                AnnualUnits: newTotal,
            };
            axios.put(`${url}/serviceCodes/${id}`, req_body).then((response) => {
                if (response.status == 400) {
                    response.json().then(function (data) {
                        alert(data.msg);
                    });
                }
            });
        },

        getAttendances() {
            this.isLoading = true;
            axios.get(`${url}/attendance/client/${this.clientID}`).then(res => {
                this.attendances = [],
                    this.tempData = res.data.attendances;
                for (var i = 0; i < this.tempData.length; i++) {
                    this.tempData[i].Date = moment(this.tempData[i].Date).format('YYYY-MM-DD');
                    this.attendances.push(this.tempData[i]);
                }
            }).finally(() => this.isLoading = false);
            //this.getCodes();
        },

        getAttendance() {
            this.isLoading = true;
            axios.get(`${url}/attendance/${this.attendanceId}`).then(res => {

                this.attendance = res.data.attendance
                this.viewAttendance(this.attendance);

            }).finally(() => this.isLoading = false);
        },

        getCodes() {
            axios.get(`${url}/serviceCodes/get/allClientCodes/${this.clientID}`).then(async res => {
                this.codes = res.data.activeServiceCodes;
            });
        },

        async addAttendance() {
            if (this.validate()) {

                this.newCode = this.newCode.ServiceCode ? this.newCode.ServiceCode : this.newCode;

                let payload = {
                    Name: this.newName,
                    Code: this.newCode,
                    Title: this.newTitle,
                    Date: this.newDate,
                    Signature: this.newSignature,
                    ClientID: this.clientID,
                    Units: this.newUnits,
                    ServiceUnit: this.newServiceUnit,
                    TimeStart: this.timeStart,
                    TimeEnd: this.timeEnd,
                    Rate: this.Rate,
                };

                try {
                    const response = await axios.post(`${url}/attendance`, payload)

                    if (response.status !== 200) {
                        displayError("An error occurred while adding the attendance record.")
                        return;
                    }

                    displaySuccess("The attendance record has been added successfully.")
                    this.getAttendances();

                } catch (error) {
                    console.log({error});
                } finally {
                    this.close();
                }
            } else {
                displayError("Please fill in all required fields.");
            }
        },
        addSignature: function () {
            if (this.signed === false) {
                this.newSignature = this.staff + " - " + new Date();
                this.signed = true;
            } else {
                this.newSignature = "";
                this.signed = false;
            }
        },

        showCodeDialog() {
            this.$store.commit("attendance/SET_DIALOG", {value: true, clientId: this.clientID});
        },

        handleNewCode(newCode) {
            this.codes.push(newCode); // Adds the new code to the existing codes array
            this.newCode = newCode.ServiceCode; // Optionally set the newly added code as the selected value
            this.newTitle = newCode.ServiceTitle;
        },

        checkTime() {
            this.timeEndAdjust = this.timeEnd;
            if (this.timeEnd < this.timeStart) {
                this.timeEndAdjust = moment(this.timeEnd, 'HH:mm').add(12, 'hours').format('HH:mm');
            }
        },

        setTimeStart(timeStart) {
            this.$refs.startTimeMenu.save(timeStart);
            // this.timeStartDisplay = this.getTimeWithPeriod(timeStart);
            // this.checkTime();
        },

        setTimeEnd(timeEnd) {
            this.$refs.endTimeMenu.save(timeEnd);
            // this.timeEndDisplay = this.getTimeWithPeriod(timeEnd);
            // this.checkTime();
        },

        getTimeWithPeriod(time) {
            const timeInfo = time.split(':');
            let hours = timeInfo[0];
            let minutes = timeInfo[1];
            let period = 'am';
            if (hours > 12) {
                hours -= 12;
                period = 'PM';
            }
            return `${hours}:${minutes} ${period}`;
        },

        async generateDownloadUrl() {
            return `${url}/attendance/print?id=${this.attendanceId}`;
        },

        async showPrintModal() {
            this.downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(this.downloadUrl, this.attendanceId, this.token,'Attendance');
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
